type BaseRequest<R> = {
	url: string;
	statusCode: number;
	unauthenticated?: boolean;
	callback: (response: Response) => Promise<R>;
};

export type GetRequest<R> = BaseRequest<R> & {
	operation: "GET";
};

export type ModifyRequest<B, R> = BaseRequest<R> & {
	operation: "POST" | "PUT" | "PATCH";
	body: B;
};

export type DeleteRequest<R> = BaseRequest<R> & {
	operation: "DELETE";
};

export type FetchRequest<B, R> =
	| GetRequest<R>
	| ModifyRequest<B, R>
	| DeleteRequest<R>;

export default class FetchFactory {
	private static readonly VOID_CALLBACK = () => Promise.resolve();
	private static readonly JSON_CALLBACK = (response: Response) =>
		response.json();

	public static get<R>(path: string): GetRequest<R> {
		return {
			operation: "GET",
			url: path,
			statusCode: 200,
			callback: FetchFactory.JSON_CALLBACK
		};
	}

	public static post<B, R>(path: string, content: B): ModifyRequest<B, R> {
		return {
			operation: "POST",
			url: path,
			body: content,
			statusCode: 201,
			callback: FetchFactory.JSON_CALLBACK
		};
	}

	public static put<B, R>(path: string, content: B): ModifyRequest<B, R> {
		return {
			operation: "PUT",
			url: path,
			body: content,
			statusCode: 200,
			callback: FetchFactory.JSON_CALLBACK
		};
	}

	public static patch<B>(path: string, content: B): ModifyRequest<B, void> {
		return {
			operation: "PATCH",
			url: path,
			body: content,
			statusCode: 204,
			callback: FetchFactory.VOID_CALLBACK
		};
	}

	public static del(path: string): DeleteRequest<void> {
		return {
			operation: "DELETE",
			url: path,
			statusCode: 204,
			callback: FetchFactory.VOID_CALLBACK
		};
	}
}
